import {useSelector} from "react-redux";
import {getHistoryArray} from "../../ducks/history-duck.js";
import {trimArrayEvenly} from "../../util/misc.js";
import {getAssetId1, getAssetId2, getMaxDuration, getStartDate} from "../../ducks/comparator-duck.js";

const MAX_ELEMENTS = 900

export const useComparatorData = () => {

    const assetId1 = useSelector(getAssetId1)
    const assetId2 = useSelector(getAssetId2)
    const maxDuration = useSelector(getMaxDuration)
    const startDate = useSelector(getStartDate)

    const history = useSelector(getHistoryArray)

    return {
        ...getRates(history, assetId1, assetId2, maxDuration, startDate),
        assetId1,
        assetId2,
    }
}

const getRates = (history, assetId1, assetId2, maxDuration, startDate) => {
    const labels = []
    const rates1 = []
    const rateRatio1 = []
    const rates2 = []
    const rateRatio2 = []
    const ratioDelta = []
    const limit = startDate ? history.length : maxDuration
    for (let i = 0; i < limit; i++) {
        const idx = history.length - 1 - i
        const [date, assets] = history[idx] || []
        if (!date) break
        if (startDate && date < startDate) break
        const rate1 = assets[assetId1]?.rate
        const rate2 = assets[assetId2]?.rate
        if (rate1 && rate2) {
            labels.push(date)
            rates1.push(rate1)
            rates2.push(rate2)
        }
    }
    const labelsCropped = trimArrayEvenly(labels, MAX_ELEMENTS)
    const rates1Cropped = trimArrayEvenly(rates1, MAX_ELEMENTS)
    const rates2Cropped = trimArrayEvenly(rates2, MAX_ELEMENTS)
    const baseline1 = rates1Cropped[rates1Cropped.length - 1]
    const baseline2 = rates2Cropped[rates2Cropped.length - 1]
    for (let i = 0; i < labelsCropped.length; i++) {
        const ratio1 = (rates1Cropped[i] / baseline1 - 1) * 100
        const ratio2 = (rates2Cropped[i] / baseline2 - 1) * 100
        rateRatio1.push(ratio1)
        rateRatio2.push(ratio2)
        ratioDelta.push(ratio1 - ratio2)
    }
    return {
        ratioDelta,
        rates1: rates1Cropped,
        rateRatio1,
        rates2: rates2Cropped,
        rateRatio2,
        labels: labelsCropped,
    }
}